import {Button, ButtonProps} from "antd";

const SuccessButton = (buttonProps: Partial<ButtonProps>) => {
  return (<Button type="primary"  {...buttonProps}/>)
}

export default SuccessButton